import React from "react";
import { Modal, Pressable, ScrollView, Dimensions } from "react-native";
import { View } from "ui/atoms/view";

export interface Props {
  isVisible: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  className?: string;
  noBackgroundClose?: boolean;
  fullScreen?: boolean;
}

export function CalendarEventModalLayout({
  isVisible,
  onClose,
  children,
  className,
  noBackgroundClose,
  fullScreen,
}: Props) {
  const windowHeight = Dimensions.get("window").height;
  const maxModalHeight = windowHeight * 0.7;

  return (
    <Modal
      visible={isVisible}
      onRequestClose={onClose}
      transparent
      animationType="fade"
    >
      <View className="p-5 flex-1 bg-black/50 items-center justify-center relative">
        {!noBackgroundClose ? (
          <Pressable
            onPress={onClose}
            className="absolute top-0 left-0 bottom-0 right-0"
          />
        ) : null}
        <View
          className={`w-96 py-10 rounded-xl bg-white drop-shadow-xl ${className}`}
        >
          <View
            className="min-h-full px-10 "
            style={fullScreen ? null : { maxHeight: maxModalHeight }}
          >
            {children}
          </View>
        </View>
      </View>
    </Modal>
  );
}
